// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hwA9P","content":"styles_content__2hJCH","tableWrap":"styles_tableWrap__llTH0"};